"use client";

import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { cn } from "@/lib/utils";

type AvatarWrapperProps = {
	src?: string;
	alt?: string;
	fallback: string;
	className?: string;
	firstName?: string;
	lastName?: string;
};

/**
 * Navbar profile avatar. Fill colour is forced via `#nav-profile-avatar` in globals.css
 * the same way `#basket-badge-count` / `#notification-badge-count` beat
 * `nav * { background: transparent !important }`.
 */
export default function AvatarWrapper({
	src,
	alt,
	fallback,
	className,
}: AvatarWrapperProps) {
	const hasImage = typeof src === "string" && src.trim().length > 0;

	return (
		<div
			id="nav-profile-avatar"
			className={cn(
				"relative inline-flex size-full min-h-0 min-w-0 items-center justify-center overflow-hidden rounded-full text-base font-bold text-white",
				className,
			)}
			style={{
				backgroundColor: "#07A8BC",
				background: "#07A8BC",
				opacity: 1,
			}}
		>
			{hasImage ? (
				<Avatar className="relative size-full bg-transparent">
					<AvatarImage src={src} alt={alt} className="size-full" />
					<AvatarFallback
						id="nav-profile-avatar-fallback"
						className="size-full font-bold"
						style={{
							backgroundColor: "#07A8BC",
							background: "#07A8BC",
							color: "#FFFFFF",
							opacity: 1,
						}}
					>
						{fallback}
					</AvatarFallback>
				</Avatar>
			) : (
				<span
					id="nav-profile-avatar-fallback"
					style={{ color: "#FFFFFF", fontWeight: "bold", opacity: 1 }}
				>
					{fallback}
				</span>
			)}
		</div>
	);
}
